import React, { useEffect } from "react";
import "./Main.css";
import Footer from "../Components/Footer";
import Header from "../Components/Header";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import CounterSection from "../HomeComponents/CounterSection";
import WhyChoose from "../HomeComponents/WhyChoose";
import WorkProcess from "../HomeComponents/WorkProcess";
import TeamMembers from "../Components/TeamMembers";
import About2 from "../HomeComponents/About2";
import HeroSection2 from "../HomeComponents/HeroSection2";
import Features from "../HomeComponents/Features";
import ScreenCarousal from "../HomeComponents/ScreenCarousal";
import PriceSection from "../HomeComponents/PriceSection";
import Faqs from "../HomeComponents/Faqs";
import Testimonial from "../HomeComponents/Testimonial";
import Blogs from "../HomeComponents/Blogs";
import ContactUs2 from "../HomeComponents/ContactUs2";
import AppPlatform from "../HomeComponents/AppPlatform";
import BannerTransition from "../HomeComponents/BannerTransition";
import PricingTableSecond from "../Components/PricingTableSecond";
import TransitionEffectsDemoAlt from "../HomeComponents/TransitionEffectsDemoAlt";
import ProductShowcase from "../HomeComponents/ProductShowcase";
import TestimonialCoverflow from "../HomeComponents/TestimonialCoverflow";

function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <BannerTransition />

      <WhyChoose />

      <About2 />

      <ProductShowcase />

      <TestimonialCoverflow />

      <Faqs />

      <Blogs />

      <Features />

      <WorkProcess />

      <Footer />
    </>
  );
}

export default Home;
